import { useRouter as useProgressRouter } from '@bprogress/next/app';
import { useRouter } from '@/i18n/routing';

/**
 * A custom hook that provides the progress router integrated with the next-intl custom router.
 * @returns The progress router instance integrated with the next-intl custom router.
 */
export const useProgressRouterIntel = () => useProgressRouter({ customRouter: useRouter });
